import store from '@/store'
import { authorityConfig } from '@/config'
import commonUtil from '@/util/commonUtil'

export default {
  // taxRate
  getTaxRateByCode(code) {
    const taxRateList = store.getters['Common/getTaxRateListFromState']
    const ret = taxRateList.find((v) => v.id === code)
    return ret.taxRate
  },
  // currency
  getCerrencyNameByCode(code) {
    const currencyList = store.getters['Common/getCurrencyListFromState']
    const ret = currencyList.find((v) => v.currencyId === code)
    return ret.name
  },
  // country
  getCountryNameById(code) {
    const countryList = store.getters['Common/countryList']
    const ret = countryList.find((v) => v.countryId === code)
    return ret.name
  },
  // storageLocation
  getPreferredStorageLocationByCode(code) {
    const preferredStorageLocationList =
      store.getters['Common/getReferredStorageLocationListFromState']
    const ret = preferredStorageLocationList.find((v) => v.id === code)
    return ret.location
  },
  // authority
  getAuthorityList() {
    return commonUtil.getStatusHistoryIdNameList(
      authorityConfig.AUTHORITY_TYPE_ID,
      authorityConfig.AUTHORITY_TYPE_LABEL
    )
  }
}
